import React from "react";
import PropTypes from "prop-types";
import { SET_GOOGLE_API_READY } from "app/actionTypes";
import { connect } from "react-redux";

export default Component => {
	class WaitForGoogle extends React.PureComponent {
		componentDidMount() {
			const { isGoogleApiReady, googleAPIKey, shop = "", dispatch } = this.props;
			if (!isGoogleApiReady) {
				const language = shop.slice(0, 2);
				const element = document.getElementsByTagName("script")[0];
				const fjs = element;
				let js = element;
				if (document.getElementById("googleapis")) {
					return;
				}
				js = document.createElement("script");
				js.id = "googleapis";
				js.src = `https://maps.googleapis.com/maps/api/js?key=${googleAPIKey}&libraries=places${
					language ? `&language=${language}` : ""
				}`;
				js.onload = () => {
					setTimeout(() => {
						dispatch({
							type: SET_GOOGLE_API_READY,
						});
					}, 5000);
				};
				fjs.parentNode.insertBefore(js, fjs);
			}
		}

		render() {
			return <Component {...this.props} />;
		}
	}

	WaitForGoogle.defaultProps = {
		shop: "",
	};

	WaitForGoogle.propTypes = {
		shop: PropTypes.string,
		googleAPIKey: PropTypes.string,
		isGoogleApiReady: PropTypes.bool,
		dispatch: PropTypes.func,
	};

	return connect(state => ({
		shop: state.shop,
		googleAPIKey: state.envVars.GOOGLE_API_KEY,
		isGoogleApiReady: state.externalStatus.isGoogleApiReady,
	}))(WaitForGoogle);
};
